import { render, staticRenderFns } from "./pageName.vue?vue&type=template&id=340700cc"
import script from "./pageName.vue?vue&type=script&lang=js"
export * from "./pageName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports